// extracted by mini-css-extract-plugin
export var button = "_ng-2";
export var card = "_ng-0";
export var closeButtonContainer = "_ng-3";
export var iconContainer = "_ng-1";